// Intentional copy: apps/dashboard/src/components/Icon.tsx is identical.
// The apps build independently and don't share a src tree; keep both in sync.
import React from 'react';
import * as FeatherIcons from 'react-feather';

export type IconName = keyof typeof FeatherIcons;

interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Icon: React.FC<IconProps> = ({ name, size = 24, color, className = '', style }) => {
  const IconComponent = FeatherIcons[name];

  if (!IconComponent) {
    return <FeatherIcons.HelpCircle size={size} color={color} className={`icon ${className}`} style={style} />;
  }

  return <IconComponent size={size} color={color} className={`icon ${className}`} style={style} />;
};

export default Icon;